var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 90,
    viewBox: "0 0 89 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3499 62.437H8.8999V66.8968H13.3499V62.437Z",
    fill: "#B5ED30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6501 62.4369V53.5173H71.2001V57.9771H17.8001V53.5173H13.3501V62.4369H75.6501Z",
    fill: "#B5ED30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6501 0H13.3501V4.45978H75.6501V0Z",
    fill: "#B5ED30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75 8.91943H22.25V13.3792H66.75V8.91943Z",
    fill: "#B5ED30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3499 4.45972H8.8999V53.5173H13.3499V4.45972Z",
    fill: "#B5ED30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0999 4.45972H75.6499V53.5173H80.0999V4.45972Z",
    fill: "#B5ED30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75 49.0574H22.25V53.5172H66.75V49.0574Z",
    fill: "#B5ED30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2 13.3792H66.75V49.0574H71.2V13.3792Z",
    fill: "#B5ED30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9002 66.8967H4.4502V71.3565H8.9002V66.8967Z",
    fill: "#B5ED30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45 71.3564H0V84.7358H4.45V71.3564Z",
    fill: "#B5ED30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0999 62.437H75.6499V66.8968H80.0999V62.437Z",
    fill: "#B5ED30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5501 66.8967H80.1001V71.3565H84.5501V66.8967Z",
    fill: "#B5ED30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9998 71.3564H84.5498V84.7358H88.9998V71.3564Z",
    fill: "#B5ED30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5502 84.7358H4.4502V89.1956H84.5502V84.7358Z",
    fill: "#B5ED30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2498 66.8967H17.7998V71.3565H22.2498V66.8967Z",
    fill: "#B5ED30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1502 66.8967H26.7002V71.3565H31.1502V66.8967Z",
    fill: "#B5ED30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0501 66.8967H35.6001V71.3565H40.0501V66.8967Z",
    fill: "#B5ED30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 75.8164H22.25V80.2762H26.7V75.8164Z",
    fill: "#B5ED30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8001 75.8164H13.3501V80.2762H17.8001V75.8164Z",
    fill: "#B5ED30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4998 75.8164H40.0498V80.2762H44.4998V75.8164Z",
    fill: "#B5ED30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5999 75.8164H31.1499V80.2762H35.5999V75.8164Z",
    fill: "#B5ED30"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48.95 66.8967H44.5V71.3565H48.95V66.8967Z",
    fill: "#B5ED30"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8499 66.8967H53.3999V71.3565H57.8499V66.8967Z",
    fill: "#B5ED30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7503 66.8967H62.3003V71.3565H66.7503V66.8967Z",
    fill: "#B5ED30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4002 75.8164H48.9502V80.2762H53.4002V75.8164Z",
    fill: "#B5ED30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2 75.8164H66.75V80.2762H71.2V75.8164Z",
    fill: "#B5ED30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3001 75.8164H57.8501V80.2762H62.3001V75.8164Z",
    fill: "#B5ED30"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2498 13.3792H17.7998V49.0574H22.2498V13.3792Z",
    fill: "#B5ED30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.4bfe606f9ea64236e388b209c8fbec66.svg";
export { ForwardRef as ReactComponent };